import React, { ReactNode } from 'react'
import Footer from '../common/footer'
import Header from '../homepage/header'
import { ErrorBoundary } from '../common/error-boundary'

interface LayoutProps {
    children: ReactNode
    responsive?: boolean
    hideFooter?: boolean
}

const Layout: React.FC<LayoutProps> = ({ children, responsive = false, hideFooter = false }) => {
    return (
        <div className={responsive ? 'responsive' : 'non-responsive'}>
            <Header responsive />
            <ErrorBoundary>{children}</ErrorBoundary>
            {!hideFooter && <Footer responsive />}
        </div>
    )
}

export default Layout
